export const PROGRESS_STAGES = ["submitted", "review", "in_progress", "approved"];

// Map a raw process status to a 0-based progress stage index.
export const statusToStageIndex = (status) => {
  switch (status) {
    case "draft":
    case "submitted":
      return 0;
    case "in_review":
      return 1;
    case "pending_approval":
    case "in_progress":
      return 2;
    case "approved":
    case "completed":
      return 3;
    default:
      return 0;
  }
};

export const DOC_STATUS_STYLES = {
  required: "bg-slate-700/40 text-slate-300 border-slate-600",
  uploaded: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  approved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  rejected: "bg-red-500/15 text-red-300 border-red-500/30",
};

// Files are private: the backend only serves them to the signed-in owner or to staff.
// Links opened in a new tab / <img> cannot send headers, so the session token travels as ?token=.
export const fileHref = (fileUrl) => {
  if (!fileUrl) return null;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  let token = null;
  try { token = localStorage.getItem("venka_token"); } catch (e) { token = null; }
  const sep = fileUrl.includes("?") ? "&" : "?";
  return token ? `${base}${fileUrl}${sep}token=${encodeURIComponent(token)}` : `${base}${fileUrl}`;
};
